import Core from '@mediaplatform/sportal365-tennis-sdk';
import { useMemo } from 'react';
import { tennis, tennisPlayoff } from '../api';
import initSmpTennisSDK from '../lib/SmpTennisSDK';
import { TennisSDKOptions as tennisOptions } from '../types';

export const getTennisApi = (sdkTennis: Core) => {
  return {
    $tennis: tennis(sdkTennis),
    $playoff: tennisPlayoff(sdkTennis),
  };
};

// Plain function to use outside React components
export const initTennisApi = (sdkOptions: tennisOptions) => {
  const sdkTennis = initSmpTennisSDK(sdkOptions);

  return getTennisApi(sdkTennis);
};

// React hook to use inside React components
export default function useTennisApi(sdkOptions: tennisOptions) {
  const sdkTennis = useMemo(() => initSmpTennisSDK(sdkOptions), [sdkOptions]);

  return useMemo(() => getTennisApi(sdkTennis), [sdkTennis]);
}
